export interface ParsedUserAgent {
	make: string;
	model: string;
}

/**
 * Parses `navigator.userAgent` to derive a device make/model, used as a fallback when the
 * User-Agent Client Hints API (`navigator.userAgentData`) is unavailable.
 */
export const parseUserAgent = (userAgent: string): ParsedUserAgent => {
	const iosMatch = new RegExp(/\b(iPhone|iPad|iPod)\b/).exec(userAgent);

	if (iosMatch) {
		return { make: 'Apple', model: iosMatch[1] };
	}

	const androidMatch = new RegExp(/;\s*([^;)]+)\s+Build\//).exec(userAgent);

	if (androidMatch) {
		const modelStr = androidMatch[1].trim();
		const parts = modelStr.split(/\s+/);

		return {
			make: parts.length > 1 ? parts[0] : 'Unknown',
			model: parts.length > 1 ? parts.slice(1).join(' ') : modelStr,
		};
	}

	return { make: 'Unknown', model: userAgent.substring(0, 32) };
};
